

async function chk_crt(cart){
    if(!cart){
    let resp  = await fetch(window.Shopify.routes.root + 'cart.js')
    if(!resp.ok){ throw new Error('Cart request failed') }
    cart = await resp.json()
    }
    let diamond_count = 0
    let diamond_count_req = 0

    cart['items'].forEach(item=>{

        if(item['product_type'] == 'api-diamond'){
            diamond_count = diamond_count + 1
        }

        if(item['product_type'] == 'lab diamond' || item['product_type'] == 'Blue Diamond' || item['product_type'] == 'pink lab diamond' || item['product_type'] == 'yellow lab diamond'){
            diamond_count_req = diamond_count_req + 1
        }
        else if(item['product_type'] == 'earrings'){
            let handle = item['handle']
            handle = handle.toLowerCase()

            if(handle.includes('lab')){
                diamond_count_req = diamond_count_req + 2
            }
        }
    })

    if(diamond_count < diamond_count_req){
       return false
    }
    else {
        return true
    }

}

function lucce_normalize_reference_title(title){
    return String(title || '')
        .replace(/\u2122/g, '')
        .replace(/\s*[-\u2013\u2014]\s*Selections?\s*$/i, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
}

function lucce_is_selection_item(item){
    return /[-\u2013\u2014]\s*Selections?\s*$/i.test(String(item.product_title || item.title || ''))
}

function lucce_get_ring_reference(item){
    if(!item || !item.properties){
        return ''
    }

    return String(item.properties['Ring Reference'] || '').trim()
}

async function lucce_sync_ring_references_before_checkout(cart){
    if(!cart){
    let resp = await fetch(window.Shopify.routes.root + 'cart.js')
    if(!resp.ok){ throw new Error('Cart request failed') }
    cart = await resp.json()
    }
    let parent_items = []
    let reference_groups = {}

    cart.items.forEach((item)=>{
        let base_title = lucce_normalize_reference_title(item.product_title || item.title)

        if(lucce_is_selection_item(item)){
            let ring_reference = lucce_get_ring_reference(item)
            if(!ring_reference){
                return
            }

            if(!reference_groups[base_title]){
                reference_groups[base_title] = []
            }

            reference_groups[base_title].push(ring_reference)
            return
        }

        if(!lucce_get_ring_reference(item)){
            parent_items.push({
                key: item.key,
                quantity: item.quantity,
                base_title: base_title,
                properties: item.properties || {}
            })
        }
    })

    for(let i = 0; i < parent_items.length; i++){
        let parent_item = parent_items[i]
        let references = reference_groups[parent_item.base_title] || []
        let ring_reference = references.shift()

        if(!ring_reference){
            continue
        }

        let properties = Object.assign({}, parent_item.properties)
        properties['Ring Reference'] = ring_reference

        let change_resp = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: parent_item.key,
                quantity: parent_item.quantity,
                properties: properties
            })
        })

        if(!change_resp.ok){
            throw new Error('Ring reference sync failed')
        }
    }
}


let chk_out_button = document.querySelector('input[name="checkout"]')
if(!chk_out_button){
    throw new Error('Checkout button not found')
}
chk_out_button.style.display = 'none'
let terms_checkbox = document.getElementById('CartTermsAgreement')
let additional_checkout_buttons = document.querySelector('.additional-checkout-buttons')
let paypal_unavailable_notice = document.querySelector('[data-paypal-unavailable]')
let cart_form = chk_out_button.closest('form')
let express_preparation_version = 0
let express_cart_ready = false
let express_preparation_pending = null
let express_cart_checked = false
let express_has_paid_globo_options = false

function cart_has_paid_globo_options(cart){
    return (cart.items || []).some((item)=>{
        let properties = item.properties || {}

        return Object.keys(properties).some((property_name)=>{
            if(property_name.charAt(0) === '_'){
                return false
            }

            return /\|\s*(?:\u20b1|PHP\s*)[\d,]+(?:\.\d+)?/i.test(String(properties[property_name] || ''))
        })
    })
}

function prepare_express_checkout(cart){
    if(express_preparation_pending){
        return express_preparation_pending
    }
    if(express_cart_checked && express_has_paid_globo_options){
        return Promise.resolve()
    }
    if(express_cart_ready || !additional_checkout_buttons){
        return Promise.resolve()
    }
    let version = ++express_preparation_version
    update_additional_checkout_state()

    express_preparation_pending = (async()=>{
    try {
        if(!cart){
            let response = await fetch(window.Shopify.routes.root + 'cart.js')
            if(!response.ok){ throw new Error('Cart request failed') }
            cart = await response.json()
        }
        if(version !== express_preparation_version){ return }
        express_has_paid_globo_options = cart_has_paid_globo_options(cart)
        express_cart_checked = true
        update_additional_checkout_state()
        if(express_has_paid_globo_options){
            return
        }
        await lucce_sync_ring_references_before_checkout(cart)
        if(version === express_preparation_version){
            express_cart_ready = true
        }
    } catch(error) {
        console.error('Express checkout preparation failed', error)
    } finally {
        if(version === express_preparation_version){
            express_preparation_pending = null
            update_additional_checkout_state()
        }
    }
    })()
    return express_preparation_pending
}

document.addEventListener('lucce:cart:updating',()=>{
    express_preparation_version++
    express_cart_ready = false
    express_preparation_pending = null
    express_cart_checked = false
    express_has_paid_globo_options = false
    update_additional_checkout_state()
})
document.addEventListener('lucce:cart:updated',(event)=>{
    prepare_express_checkout(event.detail)
})

function cart_terms_are_accepted(){
    if(!terms_checkbox){
        return true
    }

    if(terms_checkbox.checked){
        terms_checkbox.setCustomValidity('')
        return true
    }

    terms_checkbox.setCustomValidity('Please agree to the terms and conditions before checkout.')

    if(typeof terms_checkbox.reportValidity === 'function'){
        terms_checkbox.reportValidity()
    } else {
        alert('Please agree to the terms and conditions before checkout.')
    }

    terms_checkbox.focus()
    return false
}

function update_additional_checkout_state(){
    if(!additional_checkout_buttons || !terms_checkbox){
        return
    }

    let enabled = terms_checkbox.checked && express_cart_ready
    additional_checkout_buttons.hidden = !express_cart_checked || express_has_paid_globo_options
    if(paypal_unavailable_notice){
        paypal_unavailable_notice.hidden = !express_cart_checked || !express_has_paid_globo_options
    }
    additional_checkout_buttons.inert = !enabled
    additional_checkout_buttons.setAttribute('aria-disabled', String(!enabled))
    additional_checkout_buttons.style.pointerEvents = enabled ? '' : 'none'
    additional_checkout_buttons.style.opacity = enabled ? '' : '0.55'
}

function update_checkout_clone_state(){
    if(!window.lucce_checkout_button_clone || !terms_checkbox){
        return
    }

    if(terms_checkbox.checked){
        window.lucce_checkout_button_clone.removeAttribute('aria-disabled')
        window.lucce_checkout_button_clone.classList.remove('cart__submit--terms-locked')
    } else {
        window.lucce_checkout_button_clone.setAttribute('aria-disabled', 'true')
        window.lucce_checkout_button_clone.classList.add('cart__submit--terms-locked')
    }
}

if(terms_checkbox){
    terms_checkbox.addEventListener('change',()=>{
        terms_checkbox.setCustomValidity('')
        update_additional_checkout_state()
        update_checkout_clone_state()
        if(terms_checkbox.checked){ prepare_express_checkout() }
    })
    update_additional_checkout_state()
    prepare_express_checkout()
}

if(cart_form){
    cart_form.addEventListener('submit',(event)=>{
        if(event.submitter && event.submitter.name !== 'checkout'){
            return
        }

        if(!cart_terms_are_accepted()){
            event.preventDefault()
            event.stopPropagation()
        }
    },true)
}

if(additional_checkout_buttons){
    additional_checkout_buttons.addEventListener('click',(event)=>{
        if(!cart_terms_are_accepted() || !express_cart_ready){
            event.preventDefault()
            event.stopPropagation()
        }
    },true)
}


let chk_out_btn_clone = document.createElement('div')
window.lucce_checkout_button_clone = chk_out_btn_clone
chk_out_btn_clone.classList.add('cart__submit')
chk_out_btn_clone.classList.add('btn')
chk_out_btn_clone.classList.add('btn--small-wide')
chk_out_btn_clone.classList.add('cart__submit--terms-gated')
chk_out_btn_clone.setAttribute('role', 'button')
chk_out_btn_clone.setAttribute('tabindex', '0')
chk_out_btn_clone.innerHTML = 'Check Out'
document.body.append(chk_out_btn_clone)
update_checkout_clone_state()

async function handle_checkout_clone_activation(){
    if(!cart_terms_are_accepted()){
        return
    }

    chk_out_btn_clone.style.width = chk_out_btn_clone.getBoundingClientRect().width + 'px'
    chk_out_btn_clone.style.height = chk_out_btn_clone.getBoundingClientRect().height + 'px'

   //loader
   chk_out_btn_clone.innerHTML = `<div style="visibility:visible;">
   <div class="buy-customize-loader" title="1">
   <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><style>.spinner_6kVp{transform-origin:center;animation:spinner_irSm .75s infinite linear}@keyframes spinner_irSm{100%{transform:rotate(360deg)}}</style><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" class="spinner_6kVp"/></svg>
   </div>
   </div>` 

   let gpo_clone_chk_out_btn = document.querySelector('.gpo-clone-checkout-button')


    if(await chk_crt()){
        try {
            await lucce_sync_ring_references_before_checkout()
        } catch(error) {
            console.error(error)
            alert('A product in your cart is missing a ring reference. Please refresh the cart and try again.')
            chk_out_btn_clone.innerHTML = 'Check Out'
            return
        }

        if(gpo_clone_chk_out_btn){
            gpo_clone_chk_out_btn.click()
        } else{
            chk_out_button.click()
        }
    } else{
        alert('A product in your cart is missing a diamond')
        chk_out_btn_clone.innerHTML = 'Check Out'
    }
}

chk_out_btn_clone.addEventListener('click',handle_checkout_clone_activation)
chk_out_btn_clone.addEventListener('keydown',(event)=>{
    if(event.key !== 'Enter' && event.key !== ' '){
        return
    }

    event.preventDefault()
    handle_checkout_clone_activation()
})


insertAfter(chk_out_button,chk_out_btn_clone)







  

function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}



//let paypal_btn = document.getElementById('dynamic-checkout-cart')
//paypal_btn.style.display = 'none'
